/* @flow */

import _ from "lodash";
import ListPageUtils from "./ListPageUtils";
import TrackingStore from "../uidispatcherapi/TrackingStore";
import Tracking from "../uidispatcherapi/Tracking";

import Customer from "../datatypes/customer/Customer";
import { StructuredTrackingData } from "../datatypes/Tracking";

const sanitizeListType = (listType: string) => {
    if (listType === ListPageUtils.personalListOld) {
        return ListPageUtils.personalList;
    }
    if (listType === ListPageUtils.storeList) {
        return "METRO";
    }
    return listType;
};

const sanitizeSearchString = (string: string) => {
    return _.trim((string || "").toLowerCase().replace(/\s\s+/g, " "));
};

const getQuantitiyTypeOfListType = (listType: string) => {
    return listType === ListPageUtils.reorderList ? "with quantities" : "without quantities";
};

const trackUiErrorVertical = (
    vertical: string,
    component: string,
    message: string,
    exception?: any | undefined | null,
    moreData?:
        | {
              [x: string]: any;
          }
        | undefined
        | null
) => {
    if (!exception) {
        Tracking.trackError(vertical, "ui", component, message);
        console.warn("Error in component " + component + ": " + message);
    } else {
        Tracking.trackError(vertical, "ui", component, message, {
            exception: exception.stack ? exception.stack : JSON.stringify(exception),
            moreData: JSON.stringify(moreData),
            reqCti: exception.callTreeId
        });
        console.warn("Error in component " + component + ": " + message, exception);
    }
};

const trackUiErrorCa = trackUiErrorVertical.bind(null, "customerassist");
const trackUiErrorSd = trackUiErrorVertical.bind(null, "searchdiscover");

const trackStructuredEvent = (
    eventType: string,
    structuredData: StructuredTrackingData,
    hiddenData?:
        | {
              [x: string]: any;
          }
        | undefined
        | null
) => {
    Tracking.trackStructuredEvent("explore", "ui", eventType, structuredData, hiddenData);
};

const trackForGtmOnly = (
    eventType: string,
    structuredData: StructuredTrackingData,
    hiddenData:
        | {
              [x: string]: any;
          }
        | undefined
        | null
) => {
    Tracking.trackForGtmOnly("explore", "ui", eventType, structuredData, hiddenData);
};

const setCustomerInformation = (customerId: string, customer: Customer | undefined | null) => {
    if (customer) {
        try {
            TrackingStore.setCustomerInformation(customerId, {
                customerValidForFsd: customer.validForFsd,
                customerValidForWeb: customer.validForWeb,
                customerBranchCode: customer.targetGroup,
                customerSegment: customer.segment,
                customerIsTraderFranchise: customer.isTraderFranchise
            });
        } catch (error) {
            // Ignore, but we don't want tracking to kill our UI.
        }
    }
};

const setPersonId = (personId: string) => {
    try {
        if (personId) {
            TrackingStore.setPersonId(personId);
        }
    } catch (error) {
        // do not kill UI
    }
};

const setActiveContext = (activeContext: string) => {
    try {
        if (activeContext) {
            TrackingStore.setActiveContext(activeContext);
        }
    } catch (error) {
        // do not kill UI
    }
};

const exported = {
    sanitizeListType,
    sanitizeSearchString,
    getQuantitiyTypeOfListType,
    trackUiErrorCa,
    trackUiErrorSd,
    trackStructuredEvent,
    trackForGtmOnly,
    setCustomerInformation,
    setPersonId,
    setActiveContext
};

export default exported;
export {
    sanitizeListType,
    sanitizeSearchString,
    getQuantitiyTypeOfListType,
    trackUiErrorVertical,
    trackUiErrorCa,
    trackUiErrorSd,
    trackStructuredEvent,
    trackForGtmOnly,
    setCustomerInformation,
    setPersonId,
    setActiveContext
};
